import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const trackingEnabled = import.meta.env.VITE_ENABLE_VISITOR_TRACKING === 'true';

const getSessionId = () => {
  let sid = sessionStorage.getItem('visitor_sid');
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem('visitor_sid', sid);
  }
  return sid;
};

export const useVisitorTracking = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (!trackingEnabled) return;
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) return;

    const sessionId = getSessionId();
    
    supabase.functions.invoke('track-visit', {
      body: {
        session_id: sessionId,
        page_path: location.pathname,
      },
    }).catch(() => {});
  }, [location.pathname]);
};

export const trackCartEvent = (
  eventType: 'add_to_cart' | 'remove_from_cart' | 'checkout_start' | 'checkout_complete',
  productId?: string,
  productName?: string,
  quantity?: number,
) => {
  if (!trackingEnabled) return;
  const sessionId = sessionStorage.getItem('visitor_sid') || 'anonymous';
  
  supabase.functions.invoke('track-visit', {
    body: {
      session_id: sessionId,
      event_type: eventType,
      product_id: productId,
      product_name: productName,
      quantity,
    },
  }).catch(() => {});
};
